import { graphql } from "gql";

const INTERNAL_ADMIN_TAGS_QUERY = graphql(`
  query InternalAdminTags($id: [ID!]!) {
    internalAdminTag(id: $id) {
      ...InternalAdminTag
    }
  }
`);

export default INTERNAL_ADMIN_TAGS_QUERY;
